import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import { datasetWizardConfirmationIcon } from '../helper';
import { hideDatasetTypeConfirmationWizard, switchDatasetType } from '../actions';

const DatasetTypeChangeConfirmationWizard = ({
  category,
  code,
  datasourceChanged,
  hide,
  open,
  onSave,
  previousTitle,
  template,
  templateChanged,
  theme,
  title,
}) => {
  const intl = useIntl();
  const icon = datasetWizardConfirmationIcon(datasourceChanged, templateChanged);
  return (
    <Dialog
      className="aridhia-dataset-type-change-confirmation-wizard"
      icon={icon.icon}
      message={icon.message}
      messageIcon="warning circle"
      minimumDataEntryMet
      onClose={hide}
      onSave={() => onSave(category, code, previousTitle, template, title, templateChanged, datasourceChanged)}
      open={open}
      saveMessageId="actions.apply"
      theme={theme}
      title={intl.formatMessage({ id: icon.title })}
      values={{ name: `'${template.name}'` }}
      warning
    />
  );
};

const mapStateToProps = ({
  datasetSettings: { confirmWizard },
}) => ({
  ...confirmWizard,
});

const mapDispatchToProps = {
  hide: hideDatasetTypeConfirmationWizard,
  onSave: switchDatasetType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetTypeChangeConfirmationWizard);
